// apps/web/src/ui/NotifyHost.tsx
import React from "react";
import { createPortal } from "react-dom";
import { COLOR, FW } from "@/ui/tokens";

export function NotifyHost() {
    const [open, setOpen] = React.useState(false);
    const [message, setMessage] = React.useState("");

    React.useEffect(() => {
        const onEvt = (e: any) => {
            const msg = String(e?.detail?.message ?? "");
            if (!msg) return;
            setMessage(msg);
            setOpen(true);
        };
        window.addEventListener("bt:notify", onEvt);
        return () => window.removeEventListener("bt:notify", onEvt);
    }, []);

    if (!open) return null;

    return createPortal(
        <div
            onClick={() => setOpen(false)}
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,.35)",
                display: "grid",
                placeItems: "center",
                zIndex: 5000,
                padding: 16,
            }}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    width: "min(340px, 85vw)",
                    background: COLOR.white,
                    borderRadius: 14,
                    boxShadow: "0 8px 24px rgba(0,0,0,.18)",
                    padding: "24px 20px 18px",
                }}
            >
                <div style={{ fontWeight: FW.medium, fontSize: 15, color: "#222", lineHeight: 1.5, textAlign: "center", wordBreak: "keep-all" }}>
                    {message}
                </div>

                <div style={{ height: 18 }} />

                <button
                    onClick={() => setOpen(false)}
                    style={{
                        width: "100%",
                        height: 44,
                        borderRadius: 10,
                        border: "none",
                        background: COLOR.text,
                        color: COLOR.white,
                        fontSize: 14,
                        fontWeight: FW.medium,
                        cursor: "pointer",
                    }}
                >
                    확인
                </button>
            </div>
        </div>,
        document.body
    );
}
